/**
 * Create a product widget with picture, price, image and title
 * accept two type of size small and large, by default is small,
 * when a uri is added (href or ui-sref) will have a hover effect
 */
(function() {
    'use strict';
    angular.module('emarket.main.post').directive('emProduct', ['$log', '$timeout', function($log, $timeout) {
        var directive = {
            scope: {
                size: '=',
                product: '=',
                emProduct: '=',
                headerText: '=',
                headerUri: '=',
                headerTitle: '=',
                sponsor: '=?'
            },
            templateUrl: function(element, attrs) {
                var size = attrs.size;
                var template;
                if (!size || size === 'small') {
                    template = 'main/post/em-product/small.tpl.html';
                }
                if (size === 'large') {
                    template = 'main/post/em-product/large.tpl.html';
                }
                if (!template) {
                    $log.warn('Invalid size %s on directive emProduct', size);
                }
                return template;
            },
            controller: [
                '$scope',
                function($scope) {
                    var product = $scope.product || $scope.emProduct;
                    if (!product) {
                        $log.error('empty product on directive em-product');
                    }
                    $scope.mProduct = product;
                }
            ],
            link: function(scope, element, attrs) {
                if (attrs.href || attrs.uiSref) {
                    element.find('md-card').addClass('clickable');
                }
                if (attrs.headerUri) {
                    $timeout(function() {
                        var header = angular.element(element[0].querySelectorAll('md-card .em-product__header-text'));
                        header.on('click', function(event) {
                            event.stopPropagation();
                        });
                    }, 0);
                }
            }
        };
        return directive;
    }]);
}());
